import React, { useEffect } from "react";
import PropTypes from "prop-types";
import TitlePages from "../../layout/TitlePages";
import Breadcrumbs from "../../layout/Breadcrumbs";
import IconoCarpeta from "../../components/IconoCarpeta";
import "./Acuerdos.css";

const ACUERDOS_2015 = [
  {
    id: "ine-cg335-2015",
    nombre: "INE-CG335-2015",
    numero: 1,
    href: "https://itetlax.org.mx/assets/pdf/demarcaciones/acuerdos/INE-CG335-2015.pdf",
  },
  {
    id: "anexo",
    nombre: "Anexo",
    numero: 2,
    href: "https://itetlax.org.mx/assets/pdf/demarcaciones/acuerdos/anexo.pdf",
  },
  {
    id: "acuerdo-1-cnv-ext-130815",
    nombre: "ACUERDO_1_CNV_EXT_130815",
    numero: 3,
    href: "https://itetlax.org.mx/assets/pdf/demarcaciones/acuerdos/ACUERDO_1_CNV_EXT_130815-1.pdf",
  },
  {
    id: "anexo-2",
    nombre: "Anexo 2",
    numero: 4,
    href: "https://itetlax.org.mx/assets/pdf/demarcaciones/acuerdos/anexo2.pdf",
  },
  {
    id: "anexo-3",
    nombre: "Anexo 3",
    numero: 4,
    href: "https://itetlax.org.mx/assets/pdf/demarcaciones/acuerdos/anexo3.pdf",
  },
  {
    id: "ine-cg824-2015",
    nombre: "INE-CG824-2015",
    numero: 4,
    href: "https://itetlax.org.mx/assets/pdf/demarcaciones/acuerdos/INE-CG824-2015-1.pdf",
  },
];

const CarpetaAcuerdoPdf = ({ href, nombre, numero, uid }) => (
  <a
    href={href}
    target="_blank"
    rel="noreferrer"
    className="demarcaciones-card"
    aria-label={`${nombre} (Acuerdo ${numero})`}
  >
    <IconoCarpeta uid={uid} numero={numero} />
    <span className="DemarcacionesTit">{nombre}</span>
  </a>
);

CarpetaAcuerdoPdf.propTypes = {
  href: PropTypes.string.isRequired,
  nombre: PropTypes.string.isRequired,
  numero: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  uid: PropTypes.string.isRequired,
};

const Acuerdos2015 = () => {
  useEffect(() => {
    document.title = `Acuerdos 2015`;
  }, []);

  return (
    <>
      <Breadcrumbs
        path={[
          { label: "Acuerdos Demarcaciones", url: "/Acuerdos" },
          { label: "Acuerdos 2015" },
        ]}
      />
      <TitlePages title="Acuerdos 2015" subTitle="" />

      <div className="demarcaciones-acuerdos-section">
        <div className="demarcaciones-carpetas-grid">
          {ACUERDOS_2015.map((item) => (
            <CarpetaAcuerdoPdf
              key={item.id}
              uid={item.id}
              href={item.href}
              nombre={item.nombre}
              numero={item.numero}
            />
          ))}
        </div>
      </div>
    </>
  );
};

export default Acuerdos2015;
